import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ActiveTab, TabService } from "../../services/tab-service.service";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import { LanguageService } from "../../services/language.service";
import { Subscription } from "rxjs";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent implements OnInit, OnDestroy {
  private _tabService: TabService = inject(TabService);
  private _translateService: TranslateService = inject(TranslateService);
  private _router: Router = inject(Router);
  private _languageService: LanguageService = inject(LanguageService);

  ACTIVE_TAB = ActiveTab;
  activeTab!: ActiveTab;

  currentYear: number = new Date().getFullYear();
  navigation: Record<ActiveTab, { title: string; route?: string; anchor?: string }[]>  = { GIPANT: [], HENTERPANT: [], TEAMS_OR_PLAYERS: [] };
  langSubscription!: Subscription;
  tabSubscription!: Subscription;

  constructor() {
  }

  ngOnInit(): void {
    this.activeTab = this._tabService.currentTab;
    this.setNavigation();

    setTimeout(() => {
      this.activeTabSubscription();
    });

    this.languageSubscription();
  }

  activeTabSubscription(): void {
    this.tabSubscription = this._tabService.activeTab$.subscribe(tab => {
      this.activeTab = tab;

      this.setNavigation();
    });
  }

  languageSubscription(): void {
    this.langSubscription = this._languageService.onLangChange$.subscribe(() => {
      this.setNavigation();
    });
  }

  setNavigation(): void {
    this._translateService.get([
      'NAV.GIPANT.PICK_UP_REQUEST',
      'NAV.GIPANT.HOW_IT_WORKS',
      'NAV.GIPANT.FEATURES',
      'NAV.GIPANT.ABOUT_US',
      'NAV.GIPANT.CONTACT_US',

      'NAV.HENTERPANT.SLIK_FUNGERER_DET',
      'NAV.HENTERPANT.GET_STARTED',
      'NAV.HENTERPANT.GUIDANCE',
      'NAV.HENTERPANT.LEGAL_FAQ',
    ]).subscribe(translations => {
      const currentLang: string = this._translateService.currentLang;
      this.navigation = {
        GIPANT: [
          { title: translations['NAV.GIPANT.PICK_UP_REQUEST'], anchor: `pick-up-request` },
          { title: translations['NAV.GIPANT.HOW_IT_WORKS'], anchor: `how-it-works` },
          { title: translations['NAV.GIPANT.FEATURES'], anchor: `features` },
          { title: translations['NAV.GIPANT.ABOUT_US'], anchor: `about-us` },
          { title: translations['NAV.GIPANT.CONTACT_US'], anchor: `contact-us` }
        ],
        HENTERPANT: [
          { title: translations['NAV.HENTERPANT.SLIK_FUNGERER_DET'], route: `/${currentLang}/henter-pant/slik-fungerer-det` },
          { title: translations['NAV.HENTERPANT.GET_STARTED'], route: `/${currentLang}/henter-pant` },
          { title: translations['NAV.HENTERPANT.GUIDANCE'], anchor: `contact-us` },
          { title: translations['NAV.HENTERPANT.LEGAL_FAQ'], route: `/${currentLang}/henter-pant/hjelp` }
        ],
        TEAMS_OR_PLAYERS: [
          { title: translations['NAV.GIPANT.PICK_UP_REQUEST'], anchor: `pick-up-request` },
          { title: translations['NAV.GIPANT.HOW_IT_WORKS'], anchor: `how-it-works` },
          { title: translations['NAV.GIPANT.FEATURES'], anchor: `features` },
          { title: translations['NAV.GIPANT.ABOUT_US'], anchor: `about-us` },
          { title: translations['NAV.GIPANT.CONTACT_US'], anchor: `contact-us` }
        ]
      };
    });
  }

  handleNavClick(navItem: { title: string; route?: string; anchor?: string }, event: Event): void {
    if (!navItem.route && navItem.anchor) {
      event.preventDefault();
      this.scrollToAnchor(navItem.anchor!);
    }
  }

  scrollToAnchor(anchorId: string): void {
    const currentLang: string = this._translateService.currentLang;
    let baseRoute: string = '';

    if (this.activeTab === this.ACTIVE_TAB.GIPANT) baseRoute = `/${currentLang}`;
    if (this.activeTab === this.ACTIVE_TAB.HENTERPANT) baseRoute = `/${currentLang}/henter-pant`;

    this._router.navigate([baseRoute], { fragment: anchorId }).then(() => {
      setTimeout(() => {
        const el = document.getElementById(anchorId);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 0);
    });
  }

  goToPage(termsAndConditions: boolean, privacyPolicy: boolean): void {
    const currentLang: string = this._translateService.currentLang;

    let url: string = `/${currentLang}/`;
    if (this.activeTab === this.ACTIVE_TAB.HENTERPANT) url += 'henter-pant/';

    if (termsAndConditions) url += 'terms-and-conditions';
    if (privacyPolicy) url += 'privacy-policy';

    this._router.navigate([url]);
  }

  ngOnDestroy(): void {
    if (this.langSubscription) this.langSubscription.unsubscribe();
    if (this.tabSubscription) this.tabSubscription.unsubscribe();
  }
}
